<script>
    export let color = "currentColor";
    export let width = "100%";

</script>

<div style="width:{width};height:100%;max-width:100%;max-height:100%">
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 93 116"
        fill={color}
    >
        <defs>
            <style>
                .cls-1 {
                    fill-rule: evenodd;
                }

            </style>
        </defs>
        <path
            class="cls-1"
            d="M0,56.07H93V116H0V56.07ZM9.22,0H83.78L93,56.065H0ZM28.609,11.773H64.391a4.865,4.865,0,1,1,0,9.729H28.609A4.865,4.865,0,1,1,28.609,11.773Z"
        />
    </svg>
</div>
